import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.login-page {
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: #eef2f6;
}

.login-shell {
  display: grid;
  width: min(100%, 920px);
  min-height: 560px;
  grid-template-columns: minmax(330px, 0.86fr) minmax(430px, 1.14fr);
  overflow: hidden;
  border: 1px solid #dce3eb;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.12);
}

.login-visual {
  position: relative;
  overflow: hidden;
  padding: 40px;
  background: linear-gradient(145deg, #111a36 0%, #27236c 58%, #5046e5 100%);
  color: #fff;
}

.login-visual::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.15) 1px, transparent 1px);
  background-size: 22px 22px;
  opacity: 0.42;
  mask-image: linear-gradient(to bottom, #000, transparent 76%);
}

.login-visual::after {
  content: "";
  position: absolute;
  right: -105px;
  bottom: -125px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: rgba(129, 140, 248, 0.28);
  filter: blur(4px);
}

.login-visual__brand {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 10px;
}

.login-visual__brand strong {
  font-size: 15px;
  font-weight: 750;
  letter-spacing: -0.025em;
}

.login-brand__mark {
  position: relative;
  display: inline-block;
  width: 22px;
  height: 22px;
  flex: 0 0 auto;
  border-radius: 7px;
  background: #4f46e5;
}

.login-brand__mark::after {
  content: "";
  position: absolute;
  inset: 7px;
  border-radius: 2px;
  background: #fff;
}

.login-brand__mark--light {
  background: #fff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.2);
}

.login-brand__mark--light::after {
  background: #4f46e5;
}

.login-visual__art {
  position: absolute;
  inset: 90px 0 0;
  z-index: 1;
}

.login-visual__orbit {
  position: absolute;
  top: 68px;
  left: 50%;
  width: 288px;
  height: 288px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  transform: translateX(-50%);
}

.login-visual__orbit::before,
.login-visual__orbit::after {
  content: "";
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
}

.login-visual__orbit::before {
  inset: 30px;
}

.login-visual__orbit::after {
  inset: 68px;
}

.login-visual__sheet {
  position: absolute;
  top: 100px;
  left: 50%;
  display: grid;
  width: 174px;
  height: 220px;
  align-content: center;
  gap: 18px;
  padding: 36px 30px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 28px 55px rgba(8, 15, 42, 0.3);
  backdrop-filter: blur(10px);
  transform: translateX(-50%) rotate(-6deg);
}

.login-visual__sheet span {
  display: block;
  height: 7px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
}

.login-visual__sheet span:nth-child(2) {
  width: 72%;
}

.login-visual__sheet span:nth-child(3) {
  margin-top: 10px;
}

.login-visual__sheet span:nth-child(4) {
  width: 54%;
}

.login-visual__seal {
  position: absolute;
  top: 269px;
  left: calc(50% + 48px);
  width: 54px;
  height: 54px;
  border: 8px solid rgba(255, 255, 255, 0.86);
  border-radius: 50%;
  box-shadow: 0 14px 26px rgba(8, 15, 42, 0.24);
  transform: rotate(-6deg);
}

.login-visual__seal::before,
.login-visual__seal::after {
  content: "";
  position: absolute;
}

.login-visual__seal::before {
  top: 11px;
  left: 10px;
  width: 18px;
  height: 10px;
  border-bottom: 4px solid #fff;
  border-left: 4px solid #fff;
  border-radius: 2px;
  transform: rotate(-45deg);
}

.login-visual__seal::after {
  display: none;
}

.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 54px;
  background: #fff;
}

.login-panel__inner {
  width: 100%;
  max-width: 340px;
}

.login-header {
  margin-bottom: 30px;
}

.login-header h1 {
  color: #111827;
  font-size: 25px;
  line-height: 1.25;
  font-weight: 750;
  letter-spacing: -0.04em;
}

.login-form {
  display: grid;
  gap: 18px;
}

.login-field label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.login-field input {
  appearance: none;
  display: block;
  width: 100%;
  height: 47px;
  padding: 0 13px;
  border: 1px solid #d5dbe3;
  border-radius: 9px;
  background: #f9fafb;
  color: #111827;
  font-size: 13px;
  outline: none;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.login-field input::placeholder {
  color: #9aa4b2;
}

.login-field input:hover {
  border-color: #bcc5d0;
  background: #fff;
}

.login-field input:focus {
  border-color: #6366f1;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.11);
}

.login-error {
  padding: 10px 11px;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  font-size: 12px;
  line-height: 1.5;
}

.login-submit {
  display: flex;
  height: 47px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 2px;
  border-radius: 9px;
  background: #4f46e5;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 9px 22px rgba(79, 70, 229, 0.22);
  transition: background-color 140ms ease, box-shadow 140ms ease, transform 140ms ease;
}

.login-submit:hover {
  background: #4338ca;
  box-shadow: 0 11px 24px rgba(67, 56, 202, 0.25);
  transform: translateY(-1px);
}

.login-submit:active {
  transform: translateY(0);
}

.login-submit:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  box-shadow: none;
  transform: none;
}

.login-submit__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 999px;
  animation: login-spin 700ms linear infinite;
}

@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 760px) {
  .login-page {
    padding: 20px;
  }
  .login-shell {
    width: min(100%, 420px);
    min-height: 0;
    grid-template-columns: 1fr;
    border-radius: 20px;
  }
  .login-visual {
    min-height: 142px;
    padding: 26px;
  }
  .login-visual__art {
    inset: 0 0 0 42%;
    transform: scale(0.56);
    transform-origin: center;
  }
  .login-visual__orbit {
    top: -36px;
  }
  .login-visual__sheet {
    top: -18px;
  }
  .login-visual__seal {
    top: 111px;
  }
  .login-panel {
    padding: 32px 28px 34px;
  }
  .login-header {
    margin-bottom: 25px;
  }
  .login-header h1 {
    font-size: 23px;
  }
}
@media (max-width: 420px) {
  .login-page {
    padding: 16px;
  }
  .login-shell {
    border-radius: 18px;
    box-shadow: 0 22px 60px rgba(15, 23, 42, 0.11);
  }
  .login-panel {
    padding: 29px 26px 31px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .login-field input,
  .login-submit {
    transition: none;
  }
  .login-submit__spinner {
    animation-duration: 1.2s;
  }
}`],
})
export class PageLoginComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        email: '',
        password: ''
    };
    public loading: boolean = false;
    public errorMessage: string = '';

    public async ngOnInit() {
        await this.service.init();
        try {
            const { code } = await wiz.call("check");
            if (code === 200) {
                location.href = "/admin/dashboard";
                return;
            }
        } catch (e) { /* not logged in */ }
        await this.service.render();
    }

    public async login() {
        this.errorMessage = '';
        if (!this.data.email) {
            this.errorMessage = "이메일을 입력해주세요.";
            await this.service.render();
            return;
        }
        if (!this.data.password) {
            this.errorMessage = "비밀번호를 입력해주세요.";
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("login", {
            email: this.data.email,
            password: this.data.password
        });

        this.loading = false;

        if (code === 200) {
            location.href = "/admin/dashboard";
        } else {
            this.errorMessage = (data && data.message) || "로그인에 실패했습니다.";
            await this.service.render();
        }
    }
}

export default PageLoginComponent;